import RentalRequestModal from "./rental-request-modal.component";

export default RentalRequestModal;
